import React, { useEffect, useState } from 'react';
import { api } from '../api/client';
import { useAuth } from '../context/AuthContext';
import type { Overview } from '../api/types';

const Account: React.FC = () => {
  const { userId, token, logout } = useAuth();
  const [data, setData] = useState<Overview | null>(null);

  useEffect(() => {
    if (userId && token) {
      api.accountOverview(userId, token)
        .then(result => setData(result as Overview))
        .catch(console.error);
    }
  }, [userId, token]);

  const cancel = async (subId: number) => {
    try {
      await api.cancelSubscription(subId, token);
      alert('Canceled');
      setData(d => d ? { ...d, subscriptions: d.subscriptions.map(s => s.id === subId ? { ...s, status: 'CANCELED' } : s) } : d);
    } catch (e: unknown) {
      const msg = e instanceof Error ? e.message : 'Cancel failed';
      alert(msg);
    }
  };

  if (!userId) return <div className="container">Please login to view your account.</div>;
  return (
    <div className="container">
      <h2>Account Dashboard</h2>
      <button onClick={logout}>Logout</button>
      <h3>Events</h3>
      <ul>
        {data?.events.map(e => (
          <li key={e.id} className="account-item">{e.eventId} registered {new Date(e.registeredAt).toLocaleDateString()}</li>
        ))}
      </ul>
      <h3>Purchases</h3>
      <ul>
        {data?.purchases.map(p => (
          <li key={p.id} className="account-item">
            Product {p.productId} purchased {new Date(p.purchasedAt).toLocaleDateString()}
            {p.downloadToken && (
              <a
                href={`${process.env.REACT_APP_API_BASE_URL}/purchases/download/${p.downloadToken}`}
                target="_blank"
                rel="noopener noreferrer"
                className="download-link"
              >Download PDF</a>
            )}
          </li>
        ))}
      </ul>
      <h3>Subscriptions</h3>
      <ul>
        {data?.subscriptions.map(s => (
          <li key={s.id} className="account-item">{s.subscriptionPlanId} - {s.status} {s.status !== 'CANCELED' && <button className="account-cancel" onClick={() => cancel(s.id)}>Cancel</button>}</li>
        ))}
      </ul>
    </div>
  );
};
export default Account;
